import { createSelector } from 'reselect'
import { REDUX_DOMAIN_ALIAS_KEY } from 'modules/redux/constants'
import getInstancesFromDomainMapReduxUtil from 'modules/redux/utils/legacy/get-instances-from-domain-map'
import { getObjectUtil } from 'packages/src'

/**
 * Gets the section's `Categories`.
 * @returns {Category[]}
 */
function getCategoriesSelector () {
  return createSelector(
    (state, props) => props.route,
    state => state && state.categories,
    (route, categories) => {
      return getInstancesFromDomainMapReduxUtil(
        getObjectUtil(categories, `${route.section}.data`),
        getObjectUtil(categories, `${route.section}.all.data`)
      )
    }
  )
}

/**
 * Gets the category's alias.
 * @param  {string} section
 * @param  {string} category
 * @returns {string}
 */
function getAliasCategoriesSelector (section, category) {
  return createSelector(
    state => state && state.categories,
    (categories) => (
      getObjectUtil(categories, `${section}.${REDUX_DOMAIN_ALIAS_KEY}.${category}`) ||
      category
    )
  )
}

export {
  getCategoriesSelector,
  getAliasCategoriesSelector
}
